import { useEffect } from 'react';
import { gate } from 'hub-http/gates';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHasAppInstallAccess } from 'setup-guide-components/hooks/auth';
import TaskGroupCheckbox from './TaskGroupCheckbox';
import { CARD_ITEM_LEFT_ICON_SIZE_PX } from '../../../constants/layoutConstants';
import { useIsUngatedFor } from '../../../hooks/auth';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IntegrationsCard = ({
  chosenApps,
  onboardingKey,
  onIntegrationsClick
}) => {
  const isUngated = useIsUngatedFor(gate('GrowthOnboardingSetup:ConnectToolStackUpfront'));
  const hasAppInstallAccess = useHasAppInstallAccess();
  const shouldSeeIntegrationsCard = isUngated && hasAppInstallAccess && chosenApps.length !== 0;
  const {
    trackSectionView
  } = useTracker();
  useEffect(() => {
    // Only track the view of the integrations card if we render this component.
    // If the user does not have this gate or has no chosen apps, we should not track the view.
    if (shouldSeeIntegrationsCard) {
      trackSectionView('integrations card', onboardingKey, chosenApps.map(app => app.name));
    }
  }, [shouldSeeIntegrationsCard, trackSectionView, onboardingKey, chosenApps]);

  // If the user has no chosen apps remaining, we should not show the card
  if (!shouldSeeIntegrationsCard) {
    return null;
  }
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-card-locator": `${onboardingKey}-integrations-card`,
    "data-test-id": "integrations-card",
    marginBlockEnd: "0",
    children: [/*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        children: [/*#__PURE__*/_jsx(Illustration, {
          name: "integrations",
          width: CARD_ITEM_LEFT_ICON_SIZE_PX
        }), /*#__PURE__*/_jsx(Text, {
          as: "h3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.integrations.sectionHeading"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "300",
        children: [/*#__PURE__*/_jsx(View, {
          marginInline: "200",
          children: /*#__PURE__*/_jsx(TaskGroupCheckbox, {
            isChecked: false
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            children: /*#__PURE__*/_jsx(Link, {
              "data-test-id": "integrations-card-link",
              onClick: () => onIntegrationsClick(null),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "setup-guide-components.integrations.title"
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "setup-guide-components.integrations.subtitle"
            })
          }), /*#__PURE__*/_jsx(Flex, {
            gap: "200",
            children: chosenApps.map(app => /*#__PURE__*/_jsx(IconButton, {
              onClick: () => onIntegrationsClick(app.slug),
              children: /*#__PURE__*/_jsx(Image, {
                alt: app.name,
                objectFit: "contain",
                padding: "200",
                src: app.iconUrl
              })
            }, app.id))
          })]
        })]
      })
    })]
  });
};
export default IntegrationsCard;